import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var eventsIcon = /*#__PURE__*/React.createElement("svg", {
  height: "24",
  width: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.5 1c1.33 0 2.417 1.24 2.495 2.806L20 3.98a3 3 0 0 1 2.995 2.824L23 6.98v15a2.001 2.001 0 0 1-1.85 1.995l-.15.005H3a2.001 2.001 0 0 1-1.995-1.85L1 21.98v-15a3 3 0 0 1 2.824-2.995L4 3.981l.005-.175C4.083 2.24 5.17 1 6.5 1s2.417 1.24 2.495 2.806L9 3.98h6c.003-1.586 1.04-2.88 2.348-2.975L17.5 1zM4.12 4.98H4a2.002 2.002 0 0 0-1.995 1.852L2 6.98v15a1 1 0 0 0 .884.993L3 22.98h18a1 1 0 0 0 .993-.883L22 21.98v-15c0-1.103-.897-2-2-2h-3.845c.24.685.724 1.05 1.199 1.116l.118.01h.028l.015.149.004.126c0 .274-.065.642-.424.555-.933-.18-1.693-.858-1.976-1.956H5.155c.24.685.724 1.05 1.199 1.116l.118.01H6.5l.015.149.004.126c0 .274-.065.642-.424.555-.933-.18-1.693-.858-1.976-1.956zM12 12.035l1.454 2.946 3.251.473-2.352 2.293.555 3.237L12 19.455l-2.908 1.528.555-3.237-2.352-2.293 3.251-.473L12 12.034zm8-3.053v.5c0 .276-.448.5-1 .5H5c-.552 0-1-.224-1-.5v-.5h16zM17.5 1.87c-.674 0-1.421.785-1.494 1.935L16 3.98h3c-.003-1.12-.642-1.934-1.286-2.085l-.107-.02-.107-.006zm-11 0c-.674 0-1.421.785-1.494 1.935L5 3.98h3c-.003-1.182-.715-2.023-1.393-2.105L6.5 1.87z",
  fill: "currentColor",
  fillRule: "evenodd"
}));

export { eventsIcon as default };
//# sourceMappingURL=eventsIcon.js.map
